export enum Type {
  RESTING = 'RESTING',
  DRIVER_AVAILABLE = 'DRIVER_AVAILABLE',
  WORK = 'WORK',
  DRIVE = 'DRIVE'
}

export class LatestActivityEntry {
  constructor(public type: Type,
              public latestActivityStart: string,
              public latestActivityDuration: string,
              public driveBeforeBreak: string,
              public drivingLeft: string,
              public twoWeeksDrivingLeft: string,
              public nextDayRest: string) {
  }
}

export interface LatestActivityEntry {
  type: Type;
  latestActivityStart: string;
  latestActivityDuration: string;
}
